export default "__VITE_ASSET__fxSwBS6L__"